import type { EntityInstanceDto } from "@/lib/types";

/** Sidebar sentinel: list/detail fetch vehicles without `garage_register_id`. */
export const GARAGE_REGISTER_ALL_ENTITY_ID = -1;

export const GARAGE_REGISTER_ALL_ENTITY: EntityInstanceDto = {
  entity_id: GARAGE_REGISTER_ALL_ENTITY_ID,
  entity_type: "garageregister",
  entity_name: "All Garages",
};

export function isGarageRegisterAllEntities(
  entity: EntityInstanceDto | null | undefined
): boolean {
  return (
    entity != null &&
    entity.entity_type === "garageregister" &&
    entity.entity_id === GARAGE_REGISTER_ALL_ENTITY_ID
  );
}

/**
 * For GET endpoints that accept an optional `garage_register_id`:
 * omit the filter when "All Garages" is selected.
 */
export function garageRegisterIdQueryFromEntity(
  entity: EntityInstanceDto | null | undefined
): number | undefined {
  if (!entity || isGarageRegisterAllEntities(entity)) return undefined;
  return entity.entity_id;
}

type EmployeeScopeSource = {
  scoped_memberships?: Array<{ entity_id: number; entity_type: string }>;
  attachedEntities?: Array<{ id: number; type: string }>;
};

/**
 * Resolves `entity_id` / `entity_type` for employee APIs when the sidebar is "All Garages"
 * (uses the employee's garage membership).
 */
export function resolveGarageRegisterRoleScopeForEmployee(
  selectedEntity: EntityInstanceDto | null | undefined,
  employee?: EmployeeScopeSource | null
): { entity_id: number; entity_type: string } | null {
  if (!selectedEntity) return null;
  if (!isGarageRegisterAllEntities(selectedEntity)) {
    return {
      entity_id: selectedEntity.entity_id,
      entity_type: selectedEntity.entity_type,
    };
  }
  const fromMembership = employee?.scoped_memberships?.find(
    (m) =>
      m.entity_type === "garageregister" || m.entity_type === "garage_register"
  );
  if (fromMembership) {
    return {
      entity_id: fromMembership.entity_id,
      entity_type: fromMembership.entity_type,
    };
  }
  const attached = employee?.attachedEntities?.[0];
  if (
    attached &&
    (attached.type === "garageregister" || attached.type === "garage_register")
  ) {
    return { entity_id: attached.id, entity_type: attached.type };
  }
  return null;
}
